import { SPACELIFT_VCS_REPO_USED_BY_COLUMN_ID } from "../constants";
import SpaceliftVcsRepoUsedByNameCell from "./NameCell";
import SpaceliftVcsRepoUsedByRowActionsCell from "./RowActionsCell";
import SpaceliftVcsRepoUsedBySpaceCell from "./SpaceCell";

const SPACELIFT_VCS_REPO_USED_BY_TABLE_CELLS = {
  [SPACELIFT_VCS_REPO_USED_BY_COLUMN_ID.NAME]: SpaceliftVcsRepoUsedByNameCell,
  [SPACELIFT_VCS_REPO_USED_BY_COLUMN_ID.SPACE]: SpaceliftVcsRepoUsedBySpaceCell,
  [SPACELIFT_VCS_REPO_USED_BY_COLUMN_ID.ROW_ACTIONS]: SpaceliftVcsRepoUsedByRowActionsCell,
};

export default SPACELIFT_VCS_REPO_USED_BY_TABLE_CELLS;
